import Vue from 'vue';

export function snapshotRowFields(row, fields) {
  const sentValues = {};
  (fields || []).forEach((field) => {
    if (field) {
      sentValues[field] = row?.[field];
    }
  });
  return sentValues;
}

export function rowHasPendingEdits(dirtyByRow, rowId, field) {
  const dirty = dirtyByRow?.[rowId];
  if (!dirty || typeof dirty !== 'object') {
    return false;
  }
  if (field) {
    return !!dirty[field];
  }
  return Object.keys(dirty).length > 0;
}

export function selectUnchangedForceFields(sentValues, liveRow, fields) {
  return (fields || []).filter((field) => {
    if (!field || !liveRow) {
      return false;
    }
    return liveRow[field] === sentValues[field];
  });
}

export function applyIncomingRowPreservingDirty(
  target,
  incoming,
  dirtyMap = {},
  forceFields = [],
  dirtyStamp = undefined
) {
  const force = new Set(forceFields);

  Object.keys(target).forEach((k) => {
    if (!(k in incoming) && !dirtyMap[k]) {
      Vue.delete(target, k);
    }
  });

  Object.keys(incoming).forEach((k) => {
    const locallyDirty = !!dirtyMap[k];
    const editedAfterSave = !!(
      dirtyStamp &&
      locallyDirty &&
      dirtyMap[k] !== dirtyStamp[k]
    );
    if (editedAfterSave) {
      return;
    }
    if (locallyDirty && !force.has(k)) {
      return;
    }

    if (force.has(k) || target[k] !== incoming[k]) {
      Vue.set(target, k, incoming[k]);
    }
  });

  return target;
}

export function mergeRepairAssessmentPreservingDirty(
  existing = [],
  incoming = [],
  dirtyByRow = {}
) {
  const existingById = new Map(
    (existing || []).filter((row) => row && row.id).map((row) => [row.id, row])
  );

  return (incoming || []).map((row) => {
    if (!row || !row.id) {
      return row;
    }

    const local = existingById.get(row.id);
    if (!local) {
      return row;
    }

    return applyIncomingRowPreservingDirty(
      local,
      row,
      dirtyByRow[row.id] || {}
    );
  });
}
